/**
 * CallButton Component for Family App
 * Opens a modal to select a device and start a video call
 */
import React, { useState } from 'react';
import CallModal from './CallModal';

function CallButton({ seniors, devices, className = '' }) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <button
        onClick={() => setIsModalOpen(true)}
        className={className || "px-6 py-3 bg-gradient-to-r from-[#6DCEE8] to-[#5B4B8A] text-white rounded-xl font-semibold hover:shadow-lg hover:shadow-[#6DCEE8]/50 transition-all"}
      >
        📞 Videoanruf starten
      </button>

      <CallModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        seniors={seniors}
        devices={devices}
      />
    </>
  );
}

export default CallButton;
